export {
  AnalyticsEventNames,
  type AnalyticsEventName,
  type AnalyticsEntityType,
  type TrackEventInput,
  type AnalyticsEventPayloadMap,
  type BaseAnalyticsPayload,
  type GuideViewedPayload,
  type PowerViewedPayload,
  type SearchPayload,
  type CmsPayload,
  type WorkspacePayload,
} from '@/types/analytics/events';

/** Nomes enviados ao GA4 (snake_case estável). */
export const GA4_EVENT_ALIASES: Record<string, string> = {
  page_view: 'page_view',
  guide_viewed: 'guide_viewed',
  guide_updated: 'guide_updated',
  power_viewed: 'power_viewed',
  open_power: 'open_power',
  view_smilies: 'view_smilies',
  search: 'search',
  search_zero: 'search_without_results',
  article_liked: 'article_liked',
  category_opened: 'category_opened',
  workspace_card_created: 'workspace_card_created',
  workspace_card_completed: 'workspace_card_completed',
  workspace_comment_added: 'workspace_comment_added',
  cms_login: 'cms_login',
  cms_logout: 'cms_logout',
  cms_publish: 'cms_publish',
  cms_delete: 'cms_delete',
};
